jQuery(".newsletter_reveal").click(function () {
  // Show the form
  jQuery(".newsletter_reveal_section")
      .show()
      .addClass("active");

  // Hide the reveal button and the initial section
  jQuery(".newsletter_reveal").hide();
  jQuery(".newsletter_signup__inner").hide();

  // Trigger Gravity Form reinitialization after it’s shown
  jQuery(document).trigger('gform_post_render');
  
  // Animate height
  var newsletter_section_height = jQuery(".newsletter_reveal_section").height();
  jQuery(".newsletter_reveal_section").height("0px");
  jQuery(".newsletter_reveal_section").animate(
      {
          height: newsletter_section_height + "px",
      },
      500
  );
});
